import React from "react";
import { useNavigate } from "react-router-dom";

import { Icon } from "@iconify/react";

import { ContractActionSelectProps } from "js/components/Contracts/types";
import { Button } from "js/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandList,
} from "js/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "js/components/ui/popover";

import { useAppSelector } from "../../../../redux/hooks";

const ContractActionSelect: React.FC<ContractActionSelectProps> = ({
  contract,
}) => {
  const navigate = useNavigate();
  const { userData } = useAppSelector((state) => state.entities.user);
  const contractId = contract.id || "";

  const goToDetail = () => {
    if (!contractId) return;
    navigate(`/contracts/${contractId}/details`);
  };

  const goToEdit = () => {
    if (!contractId) return;
    navigate(`/contracts/${contractId}/edit`);
  };

  const menuItems = [
    {
      key: "view",
      label: "Ver detalles",
      icon: "ion:eye-outline",
      disabled: !contractId,
      onSelect: goToDetail,
    },
    ...(userData?.is_staff ||
    (userData?.user_permissions || []).some((p: string) => p.startsWith("contracts."))
      ? [
          {
            key: "edit",
            label: "Editar",
            icon: "akar-icons:edit",
            disabled: !contractId,
            onSelect: goToEdit,
          },
        ]
      : []),
  ];

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full border border-transparent text-slate-500 hover:border-slate-200 hover:bg-slate-100"
        >
          <Icon icon="mdi:dots-vertical" fontSize={18} />
          <span className="sr-only">Abrir acciones</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-48 p-0">
        <Command>
          <CommandList>
            <CommandEmpty>Sin acciones disponibles</CommandEmpty>
            <CommandGroup heading="Navegar">
              {menuItems.map((item) => (
                <CommandItem
                  key={item.key}
                  value={item.key}
                  disabled={item.disabled}
                  onSelect={() => item.onSelect()}
                  className="cursor-pointer"
                >
                  <Icon
                    icon={item.icon}
                    fontSize={16}
                    className="text-slate-400"
                  />
                  {item.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default ContractActionSelect;
